import React from 'react';
import bgImage from '../img/blur.png';
import { Paper } from '@mui/material';

const UpgradePageForTab = () => {
  return (
    <Paper
      elevation={3}
      sx={{
        height: '100vh',
        width: '100%',
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 0,
      }}
    >
      <div
        style={{
          color: '#fff',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 8px rgba(0,0,0,0.6)',
        }}
      >
        Not included in current plan,<br/> Upgrade To Continue.....
      </div>
    </Paper>
  );
};

export default UpgradePageForTab;